// extracted by mini-css-extract-plugin
module.exports = {"blue":"#6295FF","gray":"#AAB4C6"};